import sendViewItemEvent from '../../flow/gtm/sendViewItemEvent';
import { RuntimeClientAtom } from '@vs-shop/engine/runtime/RuntimeClient';

export const sendViewItemEventAtomFn = RuntimeClientAtom.fn(sendViewItemEvent);
